// extracted by mini-css-extract-plugin
export default {"ButtonComponent":"Menu_ButtonComponent__r45fT","MenuComponent":"Menu_MenuComponent__kwT0k","MenuWrapper":"Menu_MenuWrapper__XDaJs"};